import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface MintingTransactionState {
    data: [] | null | any;
    currentPage: number | null;
    totalRecords: number | null;
    totalPages: number | null;
    allMintingTransaction: [] | null | any;
}

const initialState: MintingTransactionState = {
    data: null,
    totalRecords: null,
    totalPages: null,
    currentPage: null,
    allMintingTransaction: null,
};

export const mintingTransactionSlice = createSlice({
    name: 'MintingTransaction',
    initialState,
    reducers: {
        setMintingTransaction: (state, action) => {
            state.data = action.payload.data?.data ? action.payload.data.data : action.payload.data;
            state.totalRecords = action.payload.data?.totalRecords;
            state.totalPages = action.payload.data?.totalPages;
            state.currentPage = action.payload.data?.currentPage;
        },
        setMintingTransactionBySearch: (state, action) => {
            state.data = action.payload.data?.data ? action.payload.data.data : action.payload.data;
            state.totalRecords = action.payload.data?.totalRecords;
            state.totalPages = action.payload.data?.totalPages;
            state.currentPage = action.payload.data?.currentPage;
        },
        setAllMintingTransaction: (state, action) => {
            state.allMintingTransaction = action.payload.data;
        },
        reset: (state) => {
            Object.assign(state, initialState);
        },
    },
});

export const { setMintingTransaction, setMintingTransactionBySearch, setAllMintingTransaction, reset } = mintingTransactionSlice.actions;
export const getAllMintingTransactionDetails = (state: RootState) => state.mintingTransaction.data;
export const getMintingTransactionTotalRecords = (state: RootState) => state.mintingTransaction.totalRecords;
export const getAllMintingTransactionBySearch = (state: RootState) => state.mintingTransaction.data;
export default mintingTransactionSlice.reducer;
